import { create } from 'zustand';

interface PwaState {
  /** Whether a new service worker version is available */
  readonly needRefresh: boolean;
  /** Whether the service worker update prompt was dismissed */
  readonly updateDismissed: boolean;
  /** Callback to apply the pending service worker update */
  readonly updateServiceWorker:
    | ((reloadPage?: boolean) => Promise<void>)
    | null;
  setNeedRefresh: (value: boolean) => void;
  setUpdateDismissed: (value: boolean) => void;
  setUpdateServiceWorker: (fn: (reloadPage?: boolean) => Promise<void>) => void;
}

export const usePwaStore = create<PwaState>((set) => ({
  needRefresh: false,
  updateDismissed: false,
  updateServiceWorker: null,
  setNeedRefresh: (value) =>
    set({ needRefresh: value, updateDismissed: false }),
  setUpdateDismissed: (value) => set({ updateDismissed: value }),
  setUpdateServiceWorker: (fn) => set({ updateServiceWorker: fn }),
}));
